<!-- eslint-disable vue/no-deprecated-destroyed-lifecycle -->
<template>
  <!-- 相机拍照组件 -->
  <div class="camera-container">
    <!-- 视频预览 -->
    <video v-show="!isPhoto" ref="videoPreview" class="video-preview" autoplay playsinline webkit-playsinline></video>
    <div class="controls">
      <!-- <div class="photo_operation_back action-img" @click="onBackCapturePhoto">
        <img src="@/assets/back3.png" alt="" />
      </div> -->
      <div class="photo_operation action-img" v-show="!isPhoto" @click="capturePhoto">
        <img src="@/assets/photoIcon.png" alt="" />
      </div>
      <!-- <div class="photo_operation_save action-img" v-show="isPhoto" @click="onSavePhoto">
        <img src="@/assets/match5.png" alt="" />
      </div> -->
      <div class="photo_operation_save action-img" @click="onBackCapturePhoto">
        <!-- <img src="@/assets/match5.png" alt="" /> -->
        <span style="color: #0ab95d">完成</span>
      </div>
    </div>
    <div class="videoPhoto" v-show="isPhoto">
      <img :src="currentImg" alt="" />
    </div>
    <!-- 拍照处理中：canvas 绘制 + JPEG 编码要几百毫秒，
         这段时间没有任何反馈，客户就会觉得"点了没反应" -->
    <div class="capture-loading" v-if="isCapturing">
      <span class="capture-spinner"></span>
      <span class="capture-loading-text">处理中…</span>
    </div>
    <!-- 选摄像头时的提示（探测需要 1~2 秒） -->
    <div class="camera-status" v-if="statusText">{{ statusText }}</div>
    <!-- 调试面板：地址带 ?camera_debug=1 时显示 -->
    <div class="camera-debug" v-if="debugVisible">{{ debugInfo }}</div>
  </div>
</template>

<script>
  // 后置摄像头的 label 特征
  const BACK_LABEL = /(back|rear|environment|后置|环境)/i;
  // 辅助镜头特征（长焦、超广角、微距、景深），用来降权
  const AUX_LABEL = /(telephoto|periscope|zoom|长焦|潜望|ultra|超广|广角|macro|微距|depth|景深|mono|黑白|辅助)/i;
  // 选中的主摄 label 缓存：探测一次要 1~2 秒，同机型不必每次重来
  const CAMERA_CACHE_KEY = 'camera_main_label';

  export default {
    name: 'CameraCapture',
    data() {
      return {
        videoStream: null,
        photos: [],
        isPlaying: false,
        audio: null,
        isFrontCamera: false, // 是否前置摄像头
        isPhoto: false,
        currentImg: '',
        currentFile: null,
        cameraOptions: {},
        statusText: '', // 选摄像头时的提示
        isCapturing: false, // 拍照处理中（控制 loading 遮罩）
        isDestroyed: false,
        debugVisible: false, // 地址带 ?camera_debug=1 时显示调试面板
        debugCameras: [], // 探测到的镜头列表
        debugInfo: '', // 调试面板文本
        // storeName: '',
      };
    },
    async mounted() {
      // 地址后加 ?camera_debug=1 显示调试面板，能看到每颗镜头的实测分辨率
      this.debugVisible = /camera_debug=1/.test(window.location.href);

      // 快门音先建好并预加载。原来这段排在 initializeCamera 后面，
      // 而首次进页面要探测主摄（1~2 秒），跑完才开始下载音频，
      // 客户第一次点快门时声音自然要等。
      this.initAudio();

      await this.initializeCamera();

      let options = localStorage.getItem('cameraOptions');
      if (options) {
        this.cameraOptions = JSON.parse(options);
      }
      // if (localStorage.getItem('storeName')) {
      //   this.storeName = localStorage.getItem('storeName');
      // }
    },
    // Vue 2 真正会执行的是 beforeDestroy；beforeUnmount 是 Vue 3 的名字，
    // 写在这里 Vue 2.7 不会调用，摄像头流就一直不释放。
    // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
    beforeDestroy() {
      this.releaseAll();
    },

    methods: {
      releaseAll() {
        this.isDestroyed = true;
        this.stopCamera();
        // 释放所有 Blob URL
        this.photos.forEach(photo => {
          URL.revokeObjectURL(photo.preview);
        });
        // 清除文件引用
        this.photos = [];

        if (this.audio) {
          this.audio.pause();
          this.audio.removeEventListener('ended', () => {});
          this.audio.removeEventListener('error', () => {});
          this.audio = null;
        }
      },

      // 初始化摄像头
      async initializeCamera() {
        if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== 'function') {
          alert('当前页面无法调用摄像头，需要用 HTTPS 打开');
          return;
        }

        try {
          // 先选后置主摄（前置直接返回 null，交给 facingMode）
          const deviceId = await this.pickMainCameraId();
          if (this.isDestroyed) return;

          const stream = await this.openStream(deviceId);
          if (!stream) return;

          this.videoStream = stream;
          await this.resetZoom(stream.getVideoTracks()[0]);

          const video = this.$refs.videoPreview;
          video.srcObject = stream;
          await video.play().catch(() => {});
        } catch (error) {
          console.error('摄像头访问失败:', error);
          alert('无法访问摄像头，请检查权限设置：' + ((error && error.message) || error));
        } finally {
          this.statusText = '';
          this.updateDebugInfo();
        }
      },

      /* ---------------- 选后置主摄 ---------------- */

      /**
       * H5 里 label 的编号（camera2 0 / camera2 2）跟"哪颗才是主摄"没有必然关系，
       * 按编号去猜正是之前选错的原因。
       * 这里改成实测：把每颗后置都打开一次，读 getCapabilities() 的最大分辨率。
       * 主摄的传感器像素必然最高，长焦、超广角都更低，用这个排序最可靠。
       */
      async pickMainCameraId() {
        if (this.isFrontCamera) return null;

        const cams = await this.listCamerasWithLabel();
        if (!cams.length) return null;

        const back = cams.filter(c => BACK_LABEL.test(c.label || ''));
        const candidates = back.length ? back : cams;
        if (candidates.length <= 1) {
          return candidates.length ? candidates[0].deviceId : null;
        }

        // 上次选中的直接复用，省掉每次进页面都探测。
        // 带 ?camera_debug=1 时强制重探，方便看到完整数据。
        const cached = this.debugVisible ? null : localStorage.getItem(CAMERA_CACHE_KEY);
        if (cached) {
          const hit = candidates.find(c => c.label === cached);
          if (hit) {
            console.log('[camera] 沿用上次选中的主摄:', hit.label);
            this.debugCameras = [
              { index: this.cameraIndexOf(hit.label), label: hit.label, width: 0, height: 0, selected: true },
            ];
            return hit.deviceId;
          }
        }

        this.statusText = '正在选择摄像头…';
        const probed = [];
        for (let i = 0; i < candidates.length; i++) {
          if (this.isDestroyed) return null;
          const info = await this.probeCamera(candidates[i]);
          if (info) probed.push(info);
        }
        if (!probed.length) return candidates[0].deviceId;

        // 排序规则：
        // 1) 名字里写了长焦/广角的往后排
        // 2) 比实测像素（差 10% 以上就按像素排）
        // 3) 像素差不多时按 label 编号小的优先 —— Android Camera2 里 camera 0 通常就是主摄
        probed.sort((a, b) => {
          const auxA = AUX_LABEL.test(a.label) ? 1 : 0;
          const auxB = AUX_LABEL.test(b.label) ? 1 : 0;
          if (auxA !== auxB) return auxA - auxB;

          const max = Math.max(a.pixels, b.pixels, 1);
          const diff = Math.abs(a.pixels - b.pixels) / max;
          if (diff > 0.1) return b.pixels - a.pixels;
          return a.index - b.index;
        });
        console.log('[camera] 摄像头探测结果:', probed);

        const best = probed[0];
        localStorage.setItem(CAMERA_CACHE_KEY, best.label);
        this.debugCameras = probed.map(p => ({
          index: p.index,
          label: p.label,
          width: p.width,
          height: p.height,
          selected: p.deviceId === best.deviceId,
        }));
        console.log('[camera] 选中主摄:', best.label, best.width + 'x' + best.height);
        return best.deviceId;
      },

      async listCamerasWithLabel() {
        let cams = await this.enumerateVideoInputs();
        if (cams.length && cams.every(c => c.label)) return cams;

        // label 是空的说明还没授权，开个临时流把权限要下来，再枚举一次
        const temp = await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: { facingMode: { ideal: 'environment' } },
        });
        try {
          cams = await this.enumerateVideoInputs();
        } finally {
          temp.getTracks().forEach(t => t.stop());
          // 华为等机型紧接着再开流容易 NotReadableError，留点回收时间
          await this.sleep(200);
        }
        return cams;
      },

      async enumerateVideoInputs() {
        try {
          const list = await navigator.mediaDevices.enumerateDevices();
          return list.filter(d => d.kind === 'videoinput');
        } catch (e) {
          console.warn('[camera] enumerateDevices 失败', e);
          return [];
        }
      },

      // 打开单颗摄像头，实测它能出多大画面，读完立刻释放
      async probeCamera(cam) {
        let stream = null;
        try {
          // 关键：用 ideal 把分辨率顶到最高，再看它实际给了多少。
          // 不能只看 caps.width.max —— 有些机型对每颗镜头返回同一个上限，
          // 那样按像素排序会全部打平、等于没排（这就是之前选错的原因）。
          stream = await navigator.mediaDevices.getUserMedia({
            audio: false,
            video: { deviceId: { exact: cam.deviceId }, width: { ideal: 4096 } },
          });
          const track = stream.getVideoTracks()[0];
          const caps = (track.getCapabilities && track.getCapabilities()) || {};
          const settings = (track.getSettings && track.getSettings()) || {};
          const width = settings.width || 0;
          const height = settings.height || 0;
          return {
            deviceId: cam.deviceId,
            label: cam.label || '',
            width,
            height,
            pixels: width * height,
            index: this.cameraIndexOf(cam.label),
            facing: caps.facingMode && caps.facingMode.length ? caps.facingMode[0] : '',
          };
        } catch (e) {
          console.warn('[camera] 探测失败:', cam.label, e && e.name);
          return null;
        } finally {
          if (stream) stream.getTracks().forEach(t => t.stop());
          // 不隔一下直接开下一颗，华为会报 NotReadableError
          await this.sleep(180);
        }
      },

      // label 里最后一段数字。Chrome 安卓是 "camera2 0, facing back"，
      // 不能直接 /camera (\d+)/，camera 后面跟的是 API 版本号。
      cameraIndexOf(label) {
        const nums = String(label || '').match(/\d+/g);
        return nums ? parseInt(nums[nums.length - 1], 10) : 999;
      },

      /* ---------------- 开流 ---------------- */

      async openStream(deviceId) {
        const base = deviceId
          ? { deviceId: { exact: deviceId } }
          : { facingMode: { ideal: this.isFrontCamera ? 'user' : 'environment' } };

        // 4:3 是传感器原生比例，上下不会被裁；这里**不写 aspectRatio**，
        // 写死比例会让浏览器 crop-and-scale，那才是"画面被放大"的直接原因。
        // 由高到低试三档：1920x1440 → 1280x960 → 不加任何分辨率约束。
        const widths = [
          { width: { ideal: 1920 }, height: { ideal: 1440 } },
          { width: { ideal: 1280 }, height: { ideal: 960 } },
          null,
        ];
        for (let i = 0; i < widths.length; i++) {
          const video = widths[i] ? Object.assign({}, base, widths[i]) : base;
          try {
            return await this.getUserMediaWithRetry(video);
          } catch (e) {
            console.warn('[camera] 第 ' + (i + 1) + ' 档分辨率不可用', e && e.name);
          }
        }
        return null;
      },

      async getUserMediaWithRetry(video) {
        let lastError = null;
        for (let i = 0; i < 3; i++) {
          try {
            return await navigator.mediaDevices.getUserMedia({ audio: false, video });
          } catch (e) {
            lastError = e;
            const name = (e && e.name) || '';
            const busy = name === 'NotReadableError' || name === 'TrackStartError' || name === 'AbortError';
            if (!busy || i === 2) break;
            await this.sleep(400);
          }
        }
        throw lastError;
      },

      // 有些机型会沿用上次的变焦值（zoom > 1），画面看上去就是"被放大"
      async resetZoom(track) {
        if (!track || !track.getCapabilities) return;
        try {
          const caps = track.getCapabilities();
          if (caps.zoom && typeof caps.zoom.min === 'number') {
            await track.applyConstraints({ zoom: caps.zoom.min });
          }
        } catch (e) {
          console.warn('[camera] 设置 zoom 失败', e);
        }
      },

      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },

      // 调试面板：当前流的真实分辨率和每颗镜头的实测结果
      updateDebugInfo() {
        if (!this.debugVisible) return;

        const track = this.videoStream && this.videoStream.getVideoTracks()[0];
        const s = (track && track.getSettings && track.getSettings()) || {};
        const lines = [];

        lines.push(
          '当前 ' +
            (s.width || '?') +
            'x' +
            (s.height || '?') +
            (s.zoom !== undefined ? '  zoom ' + s.zoom : '')
        );
        lines.push('镜头 ' + this.debugCameras.length + ' 颗');
        this.debugCameras.forEach(c => {
          lines.push(
            (c.selected ? '> ' : '  ') + '#' + c.index + '  ' + c.width + 'x' + c.height + '  ' + c.label
          );
        });

        this.debugInfo = lines.join('\n');
      },

      // 添加水印
      addTimestampWatermark(canvas) {
        const ctx = canvas.getContext('2d');

        // 水印内容
        // let watermarkStr = this.storeName + ' 手机拍摄 ';
        let watermarkStr = '';

        // 获取当前时间
        const now = new Date();
        const timeString = this.formatTime(now);
        if (this.cameraOptions && this.cameraOptions.time_watermark && this.cameraOptions.time_watermark == 1) {
          watermarkStr += ' ' + timeString;
        }

        // 水印样式
        const fontSize = Math.max(canvas.width * 0.02, 12);
        ctx.font = `bold ${fontSize}px Arial`;
        ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
        ctx.strokeStyle = 'rgba(0, 0, 0, 0.6)';
        ctx.lineWidth = 2;
        ctx.textAlign = 'right';
        ctx.textBaseline = 'bottom';

        // 计算文本宽度
        const textMetrics = ctx.measureText(watermarkStr);
        const textWidth = textMetrics.width;
        const textHeight = fontSize;
        const padding = fontSize * 0.5;

        // 水印位置（右下角
        const x = canvas.width - padding - 20;
        const y = canvas.height - padding;

        // 添加文字背景
        const bgPadding = padding / 2;
        const bgWidth = textWidth + bgPadding * 2;
        const bgHeight = textHeight + bgPadding * 2;
        const bgX = x - textWidth - bgPadding;
        const bgY = y - textHeight - bgPadding;

        ctx.fillStyle = 'rgba(0, 0, 0, 0.3)';
        ctx.fillRect(bgX, bgY, bgWidth, bgHeight);

        // 添加描边文字
        ctx.strokeText(watermarkStr, x, y - 2);

        // 添加填充文字
        ctx.fillStyle = 'rgba(255, 255, 255, 0.95)';
        ctx.fillText(watermarkStr, x, y);

        return canvas;
      },

      // 快门音：提前下载并解码好，点快门时直接出声，不再等网络
      initAudio() {
        this.audio = new Audio('/opt_ka.mp3');
        this.audio.preload = 'auto';
        // 只设 preload 有的浏览器要等到 play 才真的去请求，load() 才会立即开始下载
        this.audio.load();

        // 监听音频播放结束，重置状态
        this.audio.addEventListener('ended', () => {
          this.isPlaying = false;
        });

        // 监听播放错误，提示并重置状态
        this.audio.addEventListener('error', e => {
          console.error('音频播放失败：', e);
          this.isPlaying = false;
        });
      },

      playAudio() {
        if (!this.audio) return;

        // 先暂停并重置播放进度（避免重复点击叠加播放）
        this.audio.pause();
        this.audio.currentTime = 0;

        // 播放音频（需用户交互触发，浏览器安全限制）
        this.audio
          .play()
          .then(() => {
            this.isPlaying = true;
            console.log('音频开始播放');
          })
          .catch(err => {
            console.error('播放失败：', err);
            this.isPlaying = false;
          });
      },

      // 格式化时间显示
      formatTime(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },

      // 拍摄照片
      capturePhoto() {
        // 处理中再点直接忽略：原来连点会连拍出好几张一模一样的
        if (this.isCapturing) return;

        // 快门声放最前面：后面 canvas 绘制 + JPEG 编码要几百毫秒，
        // 原来等编码完才播，客户就觉得"点了半天没反应"；
        // 留在点击的同步栈里，也更不容易被浏览器的自动播放策略拦掉。
        this.playAudio();

        const video = this.$refs.videoPreview;
        if (!video || !video.videoWidth) {
          console.warn('[camera] 视频还没有出帧，本次拍摄忽略');
          return;
        }

        const startedAt = Date.now();
        this.isCapturing = true;

        const canvas = document.createElement('canvas');
        // JPEG 没有透明通道，关掉 alpha 可以让浏览器少做一层合成
        const ctx = canvas.getContext('2d', { alpha: false });
        if (!ctx) {
          console.error('[camera] 无法获取 2d 绘图上下文');
          this.stopCaptureLoading(startedAt);
          return;
        }

        // 根据视频实际分辨率设置画布（保持原始尺寸，避免拉伸模糊）
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        try {
          // 处理前置摄像头镜像
          if (this.isFrontCamera) {
            ctx.translate(canvas.width, 0);
            ctx.scale(-1, 1);
          }
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

          // 如果是前置摄像头，需要恢复坐标系以正确添加水印
          if (this.isFrontCamera) {
            ctx.setTransform(1, 0, 0, 1, 0, 0); // 重置变换矩阵
          }

          // 添加水印
          this.addTimestampWatermark(canvas);
        } catch (e) {
          console.error('[camera] 截图失败', e);
          this.stopCaptureLoading(startedAt);
          return;
        }

        return new Promise(resolve => {
          try {
            canvas.toBlob(
              blob => {
                if (!blob) {
                  console.error('[camera] 图片编码失败');
                  this.stopCaptureLoading(startedAt);
                  resolve(null);
                  return;
                }
                // 先转成 Blob
                const file = new File([blob], `photo_${Date.now()}.jpg`, {
                  type: 'image/jpeg',
                });
                const preview = URL.createObjectURL(blob);
                this.photos.push({
                  file,
                  preview: preview,
                });
                // this.isPhoto = true;
                this.currentFile = file;
                this.currentImg = preview;
                this.$emit('process-pictures', this.currentFile);
                this.stopCaptureLoading(startedAt);
                resolve(file);
              },
              'image/jpeg',
              1
            ); // 质量参数
          } catch (e) {
            console.error('[camera] 图片编码异常', e);
            this.stopCaptureLoading(startedAt);
            resolve(null);
          }
        });
      },

      // 关闭 loading。给一个最小停留时间，否则编码很快时只闪一下，
      // 看起来比没有 loading 更像"点了没反应"。
      stopCaptureLoading(startedAt) {
        const MIN_SHOW = 300;
        const elapsed = Date.now() - startedAt;
        console.log('[camera] 拍照处理耗时', elapsed, 'ms');

        const done = () => {
          if (!this.isDestroyed) this.isCapturing = false;
        };
        if (elapsed < MIN_SHOW) {
          setTimeout(done, MIN_SHOW - elapsed);
        } else {
          done();
        }
      },

      // 停止摄像头
      stopCamera() {
        if (this.videoStream) {
          this.videoStream.getTracks().forEach(track => track.stop());
          this.videoStream = null;
        }
      },

      // 切换摄像头（可选功能）
      async switchCamera() {
        this.stopCamera();
        this.isFrontCamera = !this.isFrontCamera;
        await this.initializeCamera();
      },
      onBackCapturePhoto() {
        this.isPhoto = false;
        this.$emit('to-preview');
      },
      onSavePhoto() {
        this.$emit('process-pictures', this.currentFile);
        this.isPhoto = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .camera-container {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background: #000;
    z-index: 9999;
    overflow: hidden;
  }

  .video-preview {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .controls {
    position: fixed;
    bottom: 20px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    gap: 20px;
  }

  .camera-status {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 8px 16px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    font-size: 14px;
    z-index: 10;
  }

  .camera-debug {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    padding: 6px 8px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.65);
    color: #7dff9b;
    font-size: 10px;
    line-height: 1.5;
    font-family: Menlo, Consolas, monospace;
    white-space: pre-wrap;
    word-break: break-all;
    z-index: 20;
    pointer-events: none;
  }

  .preview-list {
    display: flex;
    gap: 10px;
    padding: 10px;
    overflow-x: auto;
  }

  .preview-item {
    flex-shrink: 0;
    width: 80px;
    height: 80px;
    border: 2px solid #fff;
    border-radius: 4px;
    overflow: hidden;
  }

  .action-img {
    position: absolute;
    bottom: 36px;
    background-color: rgba(0, 0, 0, 0.8);
    padding: 10px 10px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    height: 45px;
    img {
      width: 32px;
    }
  }
  .photo_operation {
    position: absolute;
    bottom: 35px;
    left: 50%;
    transform: translateX(-50%);
    img {
      margin-right: -2px;
      margin-top: -1px;
    }
  }
  .photo_operation_back {
    left: 55px;
    img {
      margin-top: -1px;
      margin-left: -1px;
    }
  }
  .photo_operation_save {
    right: 55px;
  }
  .videoPhoto {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  // 拍照处理中的遮罩：盖住整屏，顺便挡住这段时间的误触
  .capture-loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.25);
    z-index: 15;
    pointer-events: auto;
  }

  .capture-spinner {
    width: 34px;
    height: 34px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-top-color: #fff;
    border-radius: 50%;
    animation: capture-spin 0.7s linear infinite;
  }

  .capture-loading-text {
    margin-top: 12px;
    color: #fff;
    font-size: 14px;
    letter-spacing: 1px;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  }

  @keyframes capture-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
